import Alpine from 'alpinejs'
window.Alpine = Alpine

import Feather from 'feather-icons'
window.Feather = Feather

Feather.replace()
